import { FlaskConical } from 'lucide-react'
import { useT } from '../../lib/i18n.tsx'
import { Chip } from '../../kit/Chip.tsx'

/**
 * A small badge in non-production builds (the mockup's ribbon is gone from the real app). It also says when the shell
 * runs on the development fixture session. Production builds render nothing; the bundler drops the branch.
 */
export function EnvBadge({ fixture }: { fixture?: boolean }) {
  const t = useT()
  if (import.meta.env.PROD) return null
  return (
    <span className="inline-flex items-center gap-1" data-env-badge>
      <Chip tone="warn" variant="outline" mono icon={FlaskConical} title={t('common.env.hint')}>
        {t('common.env.development')}
      </Chip>
      {fixture && (
        <Chip tone="warn" variant="soft" title={t('common.env.fixtureHint')} className="hidden lg:inline-flex">
          {t('common.env.fixture')}
        </Chip>
      )}
    </span>
  )
}
